(function () {

  	var placeholder = '#wr360embed';
    var licCode = 'PhI509sFhed+VjyJVUODSgV0h0bFD73mbbHZAaYEst6Y+xv981FTf4NPXuVgDdAykBol/Yyt3RJqa/rLWrBaPyvbvw5dhjz1JmI8hw==';
    var viewerWidth = '100%';
    var viewerHeight = '100%';
    var viewerMinHeight = 0;
    var viewerBaseWidth = 0;
    var skinName = 'thin';
    var masterCfgPath = '';
    var apiCallback = '';
    var useAnalytics = parseInt('0');
    var usePixRiot = parseInt('1');
    var pixriotFolder = '';
    var usePopup = 0;
    var graphicsPath = ''
    var isMasterCfgMode = masterCfgPath.length > 0;
    var backgroundColor = 'transparent';
    var scriptVersion = 'latest';
    var integrationPath = 'https://cdn.webrotate360.com/lib/integration/shopify/';
    var scriptHostPath = 'https://cdn.webrotate360.com/lib/imagerotator/';
    var imageRotatorURL = scriptHostPath + scriptVersion + '/js/imagerotator.js';
    var viewerSkinURL = scriptHostPath + scriptVersion + '/css/' + skinName + '.css';
  	var viewInitialized = false;
	var apiObj = null;
      
    if (graphicsPath.length == 0)
        graphicsPath = integrationPath + 'graphics';

    function setPlaceholderVisible(placeholderElm) {
        placeholderElm.css('visibility', 'visible');
    }

    function getScript(url, success) {
        var script = document.createElement('script');
        script.src = url;
        var head = document.getElementsByTagName('head')[0];
        var done = false;

        script.onload = script.onreadystatechange = function () {
            if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) {
                done = true;
                success();
                script.onload = script.onreadystatechange = null;
                head.removeChild(script);
            }
        }

        head.appendChild(script);
    }

    function getConfigFromFirstALT() {
        if (window.location.pathname.indexOf('/products/') == -1 && window.location.pathname.indexOf('/products_preview') == -1)
            return null;

        var configImageElm = null;
        var configXml = null;
        // var search = placeholder ? jQuery(placeholder).find('img') : jQuery('img');
        var search = jQuery('img');

        search.each(function (elm, index) {
            var altText = jQuery(this).attr('alt');
            if (altText && altText.length > 4 && altText.indexOf('http') == 0) {
                jQuery(this).attr('alt', '');
                if (!configXml) {
                    configImageElm = jQuery(this);
                    configXml = altText;
                }
            }
        });

        if (configImageElm && configXml) {
            return {
                element: configImageElm,
                path: configXml
            };
        }

        return null;
    }

    function loadView(configPath, placeholderElm) {
        var playerId = 'wr360_player';

        if (!configPath) {
            var config = getConfigFromFirstALT();
            if (config) {
                configPath = config.path;
                if (!placeholderElm)
                    placeholderElm = config.element;
            }
            else {
                if (placeholderElm)
                    setPlaceholderVisible(placeholderElm);
                return;
            }
        }

        setPlaceholderVisible(placeholderElm);

        if (usePopup) {
            placeholderElm.attr("id", playerId);
        }
        else {
            placeholderElm.replaceWith('<div id="wr360_wrap"></div>');
            placeholderElm = jQuery('#wr360_wrap');
            if (viewerWidth.length > 0)
                placeholderElm.css('width', viewerWidth);
            if (viewerHeight.length > 0)
                placeholderElm.css('height', viewerHeight)
            placeholderElm.html(jQuery("<div id='" + playerId + "' class='wr360_player' style='background-color:" + backgroundColor + ";'></div>"));
        }

        placeholderElm.click(function (e) {
            e.stopPropagation();
        });

        var r = WR360.ImageRotator.Create(playerId);
      
      	var xmlURLFromVariant = null;// getXMLFromVariantURL();

        r.licenseCode = licCode || 'dummy';
      	r.settings.configFileURL = xmlURLFromVariant ? xmlURLFromVariant : isMasterCfgMode ? masterCfgPath : configPath;
        r.settings.rootPath = isMasterCfgMode ? configPath : '';
        r.settings.responsiveBaseWidth = viewerBaseWidth;
        r.settings.responsiveMinHeight = viewerMinHeight;
        r.settings.graphicsPath = graphicsPath;
        r.settings.googleEventTracking = (useAnalytics != 0);
        r.settings.crossDomainConfigLoader = (usePixRiot == 0);
        if (usePopup) {
            r.settings.inBrowserFullScreen = true;
            r.settings.fullScreenOnClick = true;
        }

      	r.settings.apiReadyCallback = function(api, isFullscreen) {
          	if (!apiObj && !isFullscreen)
          		apiObj = api;
         	if (apiCallback.length > 0) {
         		var fn = window[apiCallback];
          		if (typeof (fn) === 'function') 
                  	fn(api, isFullscreen);
            }
        };

        r.runImageRotator();
      
        jQuery('.wr360-no-slide').on('pointerdown', function(e){
			e.stopPropagation();
        });
	}
  
    function initView() {
        var configPath = null,
            placeholderElm = null;

        if (placeholder) {
            placeholderElm = jQuery(placeholder);
            if (placeholderElm.length != 1) {
                if (placeholderElm.length > 0)
                    setPlaceholderVisible(placeholderElm);
                return;
            }

            if (usePixRiot && pixriotFolder) {
                var assetName = typeof __PixRiotAssetName !== 'undefined' ? __PixRiotAssetName : null;
                if (!assetName) {
                    var analyticsTrick = window.ShopifyAnalytics;
                    if (analyticsTrick.meta &&
                        analyticsTrick.meta.product &&
                        analyticsTrick.meta.product.id) {
                        assetName = analyticsTrick.meta.product.id.toString();
                    }
                }

                if (assetName) {
                    if (pixriotFolder.slice(-1) !== '/')
                        pixriotFolder += '/';
                    configPath = pixriotFolder + assetName + '/' + assetName + '.xml';

                    jQuery.ajax({
                        type: 'HEAD',
                        url: configPath,
                        success: function () {
                            loadView(configPath, placeholderElm);
                        }
                    });

                    return;
                }
            }
            else {
                var liquidData = placeholderElm.data('imagerotator');
                if (liquidData) {
                    if (typeof (liquidData.config) !== 'undefined' && liquidData.config.length > 0)
                        configPath = liquidData.config;
                    else if (typeof (liquidData.rootpath) !== 'undefined' && liquidData.rootpath.length > 0)
                        configPath = liquidData.rootpath;
                }
            }
        }

        loadView(configPath, placeholderElm);
    }
  	
    jQuery( document ).ready(function() {
      	initView();
    });

  
})();